import React, { useState, useEffect } from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form"

import { apiDelete, apiGet, apiPost, apiPut } from "../../api/server"

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const CopyEvent = (props) => {

    const [events, setEvents] = useState([]);
    const [publish, setPublish] = useState(false);


    function addEvent(){
        let newEvents = [...events];
        newEvents.push({index: newEvents.length, startTime: props.originalStartTime, endTime: props.originalEndTime})
        setEvents(newEvents)
    }

    function changeStartTime(index, startTime){
        let newEvents = [...events];
        newEvents[index].startTime = startTime
        setEvents(newEvents)
    }

    function changeEndTime(index, endTime){
        let newEvents = [...events];
        newEvents[index].endTime = endTime
        setEvents(newEvents)
    }

    function handleSubmit(){
        events.forEach(event => {
            event.startTime = event.startTime.toISOString()
            event.endTime = event.endTime.toISOString()
        })

        const body = {
            originalId: props.originalEventId,
            newEvents: events,
            publish: publish
        }
       
        apiPut(`intranetevents/copyevent`, body)
        .then(response => {if(response.ok){
            setEvents([])
            console.log(response)
            props.setCopyOn(false)
          
        }})
        .catch( err => console.log(err) )
    }
    console.log(events)
    return (
        <Modal dialogClassName="copy-event-modal"  show={props.copyOn} onHide={() => props.setCopyOn(false)}>
            <Modal.Header closeButton>
            <Modal.Title>Copy Event</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col xs={4}> Original Event Id: {props.originalEventId}</Col>
                    <Col xs={4}> Original Start: {props.originalStartTime.toLocaleString('en-GB')}</Col>
                    <Col xs={4}> Original End: {props.originalEndTime.toLocaleString('en-GB')}</Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <h4>New Events</h4>
                    </Col>
                    <Col md={6}>
                        <Form.Check checked={publish} onChange={(event) => {setPublish(event.target.checked)}} label="Publish?" />
                    </Col>
                    
                </Row>
                {events.map(event => {
                    console.log(event)
                    return (
                        <>
                        <Row>
                            <Col md={6}>
                            <Form.Group controlId="blogCreate.image">
                                <Form.Label>Start</Form.Label>
                                <DatePicker 
                                    selected={event.startTime} 
                                    onChange={(date) => changeStartTime(event.index, date)}
                                    showTimeSelect
                                    locale="enGB"
                                    dateFormat='dd/MM/yyyy HH:mm'
                                />
                            </Form.Group>
                            </Col>
                            <Col md={6}>
                            <Form.Group controlId="blogCreate.image">
                                <Form.Label>End</Form.Label>
                                <DatePicker 
                                    selected={event.endTime} 
                                    onChange={(date) => changeEndTime(event.index, date)}
                                    showTimeSelect
                                    locale="enGB"
                                    dateFormat='dd/MM/yyyy HH:mm'
                                />
                            </Form.Group>
                            </Col>
                        </Row>

                        </>
                    )
                })}
                <Button onClick={addEvent}>Add Another</Button>
                <div style={{height:"200px"}}></div>
            </Modal.Body>
            <Modal.Footer>
            <Button variant="primary" onClick={handleSubmit}>
                Save
            </Button>
            <Button variant="secondary" onClick={() => props.setCopyOn(false)}>
                Exit
            </Button>
            
            </Modal.Footer>
        </Modal>
    )
}

export default CopyEvent;